import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import React from 'react'
import TraditionalInquire from './traditional-office-inquire'
import InquireCommon from './inquire-common'
import BuildingInquire from './building-inquire'

const Inquire = (props) => {
  const { categorySlug, space } = props
  const { version } = space
  const isV1TraditionalOffice = categorySlug === 'traditional-office' && version && version === 'v1'

  const switchOnCategorySlug = () => {
    if (isV1TraditionalOffice) {
      return <TraditionalInquire {...props} />
    } else if (categorySlug === 'building-page') {
      return <BuildingInquire {...props} />
    }
    return <InquireCommon {...props} />
  }

  return switchOnCategorySlug()
}

Inquire.propTypes = {
  title: PropTypes.string,
  capacity: PropTypes.string,
  prices: PropTypes.array,
  spaces: PropTypes.array,
  categorySlug: PropTypes.string,
  place: PropTypes.string,
  toggle: PropTypes.func.isRequired,
  isOpen: PropTypes.bool.isRequired,
  showOption: PropTypes.bool,
  space: PropTypes.object,
}
const mapStateToProps = ({ space }) => ({
  space: space.spaceInfo,
})

export default connect(mapStateToProps)(Inquire)
